import { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';
import type { MermaidProps } from '../types';

mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
  securityLevel: 'loose',
  themeVariables: {
    background: '#ffffff',
    primaryColor: '#e0f2fe',
    primaryTextColor: '#1e293b',
    primaryBorderColor: '#0284c7',
    lineColor: '#334155',
    secondaryColor: '#f0fdf4',
    tertiaryColor: '#fef3c7',
  },
});

export function Mermaid({ chart }: MermaidProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [svg, setSvg] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const renderChart = async () => {
      if (!containerRef.current || !chart.trim()) return;

      try {
        const id = `mermaid-${Math.random().toString(36).substring(2, 9)}`;
        const { svg } = await mermaid.render(id, chart.trim());
        setSvg(svg);
        setError(null);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : 'Failed to render diagram'
        );
        setSvg('');
      }
    };

    renderChart();
  }, [chart]);

  if (error) {
    return (
      <div className="my-4 rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-900 dark:bg-red-950">
        <p className="text-sm text-red-600 dark:text-red-400">
          Mermaid error: {error}
        </p>
        <pre className="mt-2 overflow-x-auto text-xs text-red-800 dark:text-red-200">
          {chart}
        </pre>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="my-4 flex justify-center overflow-x-auto rounded-lg bg-white p-4"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
